import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  JobWorkflowSettingsDto,
  WorkflowRequestDto,
} from 'src/api/FiretrolApiClient';
import {
  jobApiClient,
  workflowApiClient,
} from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useSaveJobWorkflow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobId,
      workflowId,
      request,
    }: {
      jobId: number;
      workflowId: string;
      request: WorkflowRequestDto;
    }) => workflowApiClient.update(jobId, workflowId, request),
    meta: { suppressErrorToast: true, errorContext: 'job workflow save' },
    onSettled: (_data, _err, { jobId }) =>
      invalidateFor('workflow.update', qc, { jobId }),
  });
}

/** @registry Assigns each module's workflow on a job; refreshes the job DTO its consumers read. */
export function useUpdateJobWorkflows() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      jobId,
      settings,
    }: {
      jobId: number;
      divisionId?: number;
      settings: JobWorkflowSettingsDto;
    }) => jobApiClient.updateWorkflows(jobId, settings),
    meta: { successMessage: 'Workflow Settings Updated!' },
    onSettled: (_data, _err, { jobId, divisionId }) =>
      invalidateFor('job.workflows.update', qc, { jobId, divisionId }),
  });
}
